export default __webpack_public_path__ + "04593b7cd9a2f059fca0ea40a56454c1.png";